// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"186":"events-detail","315":"assign-form","693":"events-home","873":"users-home","898":"users-detail"}[chunkId] || chunkId) + ".js";
};